import { observer } from 'mobx-react-lite'
import { useAbility } from '@casl/react'
import { TopBar } from 'components/Design/TopBar/TopBar'
import { AbilityContext } from 'components/Can'
import { useAuth } from 'hooks/UseAuth'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useWorkspace } from 'hooks/useWorkspace'
import { useRootStore } from 'stores/RootStore'
import { SubjectType } from 'utils/caslAbility'
import { getUserRole } from 'utils/workspaceUtils'
import { Header } from './Header'
import { MobileVideoEditorHeader } from './MobileVideoEditorHeader'
import { VideoEditorHeaderProps } from './Types'
import Styles from './VideoEditorHeader.module.scss'

const VideoEditorHeader = observer(({ fileId }: VideoEditorHeaderProps) => {
  const { files } = useRootStore()
  const ability = useAbility(AbilityContext)
  const auth = useAuth()
  const file = files.get(fileId)
  const workspace = useWorkspace(file?.workspace.id ?? null)

  const authedFile = {
    role: getUserRole(workspace, auth),
    version_control_mode: file?.workspace.version_control_mode,
    permissions: file?.permissions,
    isAssociatedAdPublished: !!file?.is_related_ad_published,
    __caslSubjectType__: SubjectType.DESIGN,
  }

  const canEdit = ability.can('edit', authedFile)

  return (
    <Header data-testid="video-editor-header" className={Styles.header}>
      <TopBar fileId={fileId} canEdit={canEdit} />
    </Header>
  )
})

const VideoEditorHeaderContainer = (props: VideoEditorHeaderProps) => {
  const { isMobile } = useResponsiveDesign()

  return isMobile ? <MobileVideoEditorHeader {...props} /> : <VideoEditorHeader {...props} />
}

export { VideoEditorHeaderContainer as VideoEditorHeader }
